<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">Banner管理</span>
      </div>
      <div class="right">
        <Button type="primary" @click="openModal(false)">新增Banner</Button>
      </div>
    </div>

    <div>
      <Table :columns="columns" :data="list" />
    </div>

    <Modal v-model="modal.visible" title="编辑" :width="800">
      <Form ref="form" :model="modal.data" :rules="modal.rule" :label-width="100">
        <FormItem prop="seat" label="显示位置:">
          <Select v-model="modal.data.seat">
            <Option v-for="(item, index) in seatData" :value="index" :key="index">{{ item }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="name" label="名称:">
          <Input v-model="modal.data.name" placeholder="请填写banner名称" />
        </FormItem>
        <FormItem prop="sorts" label="排序值:">
          <Input v-model="modal.data.sorts" />
        </FormItem>
        <FormItem prop="img" label="图片:" class="imgbox">
          <div class="uploadImg">
            <Icon v-if="!modal.data.img" type="ios-add" class="icon" />
            <img v-else :src="modal.data.img" alt="" class="img" @change="choose($event, 1)" />
            <input type="file" id="carousel" class="input" ccept="image/png, image/jpeg, image/gif, image/jpg"
              @change="choose($event, 1)" />
          </div>
        </FormItem>
        <FormItem prop="open_type" label="跳转方式:">
          <RadioGroup v-model="modal.data.open_type">
            <Radio :label="0">不跳转</Radio>
            <Radio :label="1">小程序</Radio>
            <Radio :label="2">网页</Radio>
            <Radio :label="3">当前小程序页面</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem prop="app_id" label="AppId:" v-if="modal.data.open_type === 1">
          <Input v-model="modal.data.app_id" placeholder="请填写要跳转的小程序app_id" />
          <Tag color="default">自营新零售：wx55b89d627937a5ef</Tag>
          <Tag color="default">自营新零售体验：wx763a7c36fcde6750</Tag>
        </FormItem>
        <FormItem prop="original_id" label="原始ID:" v-if="modal.data.open_type === 1">
          <Input v-model="modal.data.original_id" placeholder="请填写要跳转的小程序原始ID" />
          <Tag color="default">自营新零售：gh_dc097d7befb8</Tag>
          <Tag color="default">自营新零售体验：gh_ac5adc1d6271</Tag>
        </FormItem>
        <FormItem prop="path" v-if="modal.data.open_type"
          :label="modal.data.open_type === 1 ? '跳转路径:' : modal.data.open_type === 3 ? '页面路径:' : '网页地址'">
          <Input v-model="modal.data.path" :placeholder="modal.data.open_type === 1 || modal.data.open_type === 3
            ? '请填写要跳转的小程序路径'
            : '请填写要跳转的网页地址'
            " />
          <p style="font-size: 12px; color: #555">为空则默认跳转到首页</p>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button size="large" @click="modal.visible = false">取消</Button>
        <Button type="primary" size="large" @click="saveBanner" :loading="modal.Loading">确定</Button>
      </div>
    </Modal>

    <!-- <div class="cropperWrap" v-if="cropper.preview && cropper.visible">
      <div class="wrapbox">
        <VueCropper
          ref="cropper"
          :img="cropper.preview"
          :autoCropWidth="cropper.autoCropWidth"
          :autoCropHeight="cropper.autoCropHeight"
          :autoCrop="cropper.autoCrop"
          :fixedBox="cropper.fixedBox"
          :outputSize="cropper.outputSize / 100"
          :enlarge="cropper.enlarge"
        ></VueCropper>
        <div class="control">
          <div style="width: 750px">
            图片质量:
            <Slider
              v-model="cropper.outputSize"
              :min="10"
              :step="10"
              :disabled="cropper.preview ? false : true"
            ></Slider>
          </div>
          <Button type="warning" @click="$refs.cropper.rotateLeft()"
            >左转</Button
          >
          <Button type="primary" @click="uploadImage">确定上传</Button>
          <Button type="warning" @click="$refs.cropper.rotateRight()"
            >右转</Button
          >
          <Button type="error" @click="close">关闭</Button>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { VueCropper } from 'vue-cropper'
import OSS from 'ali-oss'
import config from '../../../config'
const seatData = ['首页顶部', '首页底部', '个人中心底部', '钱包底部']
export default {
  components: { VueCropper },
  data () {
    return {
      seatData,
      modal: {
        visible: false,
        Loading: false,
        data: {
          id: 0,
          name: '',
          img: '',
          status: 0,
          app_id: '',
          path: '',
          open_type: 0,
          seat: 0,
          sorts: 0,
          original_id: ''
        },
        rule: {
          name: [
            { required: true, message: '请输入banner名称', trigger: 'blur' }
          ],
          img: [
            { required: true, message: '请上传banner图片', trigger: 'blur' }
          ]
        }
      },
      cropper: {
        visible: false,
        preview: '', // 预览 base64
        autoCrop: true,
        outputSize: 100, // 图片质量
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 750,
        autoCropHeight: 580,
        fileType: '',
        fixedBox: true,
        enlarge: 2
      },
      list: [],
      columns: [
        { title: '编号', key: 'id' },
        { title: '名称', key: 'name' },
        {
          title: '图片',
          render: (h, data) => {
            console.log('data.row.img', data.row.img)
            return h('img', {
              attrs: {
                src: data.row.img
              },
              style: {
                height: '50px'
              }
            })
          }
        },
        { title: 'AppId', key: 'app_id' },
        { title: '跳转路径', key: 'path' },
        {
          title: '显示位置',
          render: (h, data) => {
            return h('span', {}, seatData[data.row.seat])
          }
        },
        {
          title: '排序', key: 'sorts'
        },
        {
          title: '操作',
          key: 'operate',
          render: (h, data) => {
            return h('div', {}, [
              h(
                'Button',
                {
                  props: {
                    size: 'small',
                    type: data.row.status ? 'success' : 'error'
                  },
                  on: {
                    click: () => {
                      let params = JSON.parse(JSON.stringify(data.row))
                      if (params.status) params.status = 0
                      else params.status = 1
                      if (!params.sorts) params.sorts = 0
                      delete params._index
                      delete params._rowKey
                      this.SaveBanner(params).then(res => {
                        this.getData()
                      })
                    }
                  }
                },
                data.row.status ? '显示' : '隐藏'
              ),
              h(
                'Button',
                {
                  props: { size: 'small', type: 'warning' },
                  style: { marginLeft: '5px' },
                  on: {
                    click: () => {
                      this.openModal(JSON.parse(JSON.stringify(data.row)))
                    }
                  }
                },
                '修改'
              )
            ])
          }
        }
      ]
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    ...mapActions(['GetBanner', 'SaveBanner']),
    openModal (row) {
      let data = {
        id: 0,
        name: '',
        img: '',
        status: 0,
        app_id: '',
        path: '',
        open_type: 0,
        seat: 0,
        sorts: 0,
        original_id: ''
      }
      if (row) {
        data = {
          id: row.id,
          name: row.name,
          img: row.img,
          status: row.status,
          app_id: row.app_id,
          path: row.path,
          open_type: row.open_type,
          seat: row.seat,
          sorts: row.sorts,
          original_id: row.original_id
        }
      }
      this.modal.data = data
      this.modal.visible = true
    },
    saveBanner () {
      this.$refs.form.validate((valid) => {
        if (!valid) return false
        let data = JSON.parse(JSON.stringify(this.modal.data))
        console.log(data)
        if (data.open_type === 1 && !data.app_id) {
          this.$Message.error('请填写appid')
          return false
        } else if (data.open_type === 1 && !data.original_id) {
          this.$Message.error('请填写原始ID')
          return false
        } else if (data.open_type === 2 && !data.path) {
          this.$Message.error('请填写要打开的网页地址')
          return false
        }
        this.modal.Loading = true
        this.SaveBanner(data)
          .then((res) => {
            this.modal.Loading = false
            this.modal.visible = false
            this.$Message[res.status ? 'success' : 'error'](res.msg)
            res.status && this.getData()
          })
          .catch((e) => {
            this.modal.Loading = false
          })
      })
    },
    getData () {
      this.GetBanner().then((res) => {
        this.list = res.data
      })
    },
    choose (e, type) {
      let file = e.target.files[0]
      if (file) {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
          this.$Message.error('仅支持图片文件')
          return
        }
        /* this.cropper.visible = true;
        let temp = file.name.split(".");
        this.cropper.fileType = temp[temp.length - 1];
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          console.log(e.currentTarget.result);
          this.cropper.preview = e.currentTarget.result;
        }; */
        const OssClient = new OSS({
          region: config.oss.region,
          endpoint: config.oss.region,
          accessKeyId: config.oss.accessKeyId,
          accessKeySecret: config.oss.secretAccessKey,
          bucket: config.oss.bucket
        })
        OssClient.put('banner/' + new Date().getTime() + '.jpg', file)
          .then((res) => {
            this.modal.data.img = res.url
            this.$Message.success('上传成功')
          })
          .catch((err) => {
            this.$Message.error('error')
          })
      }
    },
    close () {
      this.cropper.preview = ''
    },
    uploadImage () {
      this.$refs.cropper.getCropBlob((data) => {
        if (data.size > 1024 * 1024) {
          this.$Modal.warning({
            title: '图片过大',
            content: '截图区域生成的文件过大,推荐挪动图片或降低图片质量'
          })
          return
        }

        const OssClient = new OSS({
          region: config.oss.region,
          endpoint: config.oss.region,
          accessKeyId: config.oss.accessKeyId,
          accessKeySecret: config.oss.secretAccessKey,
          bucket: config.oss.bucket
        })
        OssClient.put('banner/' + new Date().getTime() + '.jpg', data)
          .then((res) => {
            this.cropper.visible = false
            console.log(res)
            this.modal.data.img = res.url
            this.$Message.success('上传成功')
          })
          .catch((err) => {
            this.$Message.error('error')
          })
      })
    }
  },
  computed: mapGetters({}),
  watch: {}
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
